import state from './leadState'
import mutations from './leadMutation'
import getters from './leadGetters'
import actions from './leadAction'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
